export default __webpack_public_path__ + "static/media/erm-sp.64ee5419.svg";